<template>
  <div class="gift-note">
    <button
      aria-label="toggle gift wrapping"
      class="gift-wrap--toggle"
      @click="toggleGiftWrap"
    >
      <div class="gift-note--label">
        <span class="gift-note--toggle-icon f old-mr-2">
          <svg-gift-wrap></svg-gift-wrap>
        </span>
        <span class="gift-note--text lg--fs-12 sm--fs-10 c-old-spice"
          >Wrapping & Gift Notes</span
        >
      </div>

      <div class="gift-note--right">
        <span class="plaid-l c-old-spice fs-12">+ ADD</span>
      </div>
    </button>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "cart-gift-wrap-toggle",
  computed: {
    text() {
      return theme.strings.giftWrap || "";
    },
  },
  methods: {
    ...mapActions({
      toggleGiftWrap: "cart/toggleGiftWrap",
    }),
  },
};
</script>
